module.exports = "<itpx-evaluation-learning-tile [deliverableStatus]=\"deliverableStatus\" [status]=\"status\" [target]=\"target\" [logo]=\"'elearning.png'\"\n                    [name]=\"name\" [errorMessage]=\"errorMessage\" [disabled]=\"deliverable.disabled\"\n                    [availableUntil]=\"deliverable.availableUntil\" [deliverable]=\"deliverable\" [isElearning]=\"true\">\n</itpx-evaluation-learning-tile>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/content/scormcloud/tile.component.html
// module id = 884
// module chunks = 0